import request from '@/common/request'
export default {
  queryMenuTree: params => {
    return request({
      url: '/permission/menuTree',
      method: 'get',
      params
    })
  },
  
  createPermission: (data) => {
    return request({
      url: '/permission',
      method: 'post',
      data     
    })
  },
  deletePermission: (dynaSeg ) => {
    return request({
      url: `/permission/delPermis/${dynaSeg.id}`,
      method: 'delete'
    })
  },
  updatePermission: (dynaSeg, data, params) => {
    return request({
      url: `/permission/${dynaSeg.id}`,
      method: 'put',
      data,
      params
    })
  },
  queryPermission: params => {
    return request({
      url: '/permission/0',
      method: 'get',
      params
    })
  }
}


// WEBPACK FOOTER //
// ./src/api/modules/permission.js